module.exports = function () {
    // Imports
    const API = require('../../lib/api-base.js');
    const Event = require('../../lib/simpleevents.js');

    var M = {};
    M.OnUniqueResult = new Event(M);
    M.OnSuggestionsResult = new Event(M);
    M.OnValidPasswordResult = new Event(M);

    var api = API(M, 'api/SkyCommunityUser', { UseLoader: false });

    api.AddHook('GetSuggestions', 'POST', 'Success')
        .OnSuccess(function (data, args) {
            M.OnSuggestionsResult.Notify(data);
        });

    api.AddHook('ValidatePassword', 'POST', 'Success')
        .OnSuccess(function (data, args) {
            M.OnValidPasswordResult.Notify(data);
        });

    api.AddHook('IsUnique', 'POST', 'Success')
        .OnSuccess(function (data, args) {
            M.OnUniqueResult.Notify({
                IsUnique: data.IsUnique,
                CommunityID: args.communityID
            });
        });

    return M;
}


// WEBPACK FOOTER //
// ./Scripts/views/signup/controller.js